import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "../utils/interceptor";

const getEarningsService = (
  searchText: any,
  activeTab: any,
  status?: any,
  from?: any,
  to?: any,
  itemsPerPage?: number
) => {
  const params = new URLSearchParams();
  if (status || status === 0) params.append("status", status);
  if (searchText) params.append("search", searchText);
  if (activeTab) params.append("page", activeTab.toString());
  if (itemsPerPage) params.append("per_page", itemsPerPage.toString());
  if (from && to) {
    params.append("from", from);
    params.append("to", to);
  }
  const url = `${Endpoint.accountant.getEarnings}?${params.toString()}`;
  return HTTP_CLIENT.get(url);
};

const uploadReceiptService = (resp: {}) => {
  return HTTP_CLIENT.post(Endpoint.accountant.uploadReceipt, resp);
};

// Book-level sales breakdown (B2C users / B2B schools) behind an earning
const getEarningBookSalesService = (earningId: any, type?: string) => {
  const params = new URLSearchParams();
  if (type) params.append("type", type);
  const url = `${Endpoint.accountant.earningBookSales.replace(
    ":id",
    earningId
  )}?${params.toString()}`;
  return HTTP_CLIENT.get(url);
};

const getStatsService = () => {
  return HTTP_CLIENT.get(Endpoint.accountant.getStats);
};

const createCouponService = (data: any) => {
  return HTTP_CLIENT.post(Endpoint.accountant.createCoupon, data);
};

const getCouponsService = (
  searchText?: string,
  activePage?: number,
  itemsPerPage?: number,
  status?: number,
  type?: number
) => {
  const params = new URLSearchParams();
  if (searchText) params.append("search", searchText);
  if (activePage) params.append("page", activePage.toString());
  if (itemsPerPage) params.append("per_page", itemsPerPage.toString());
  if (status !== undefined && status !== null)
    params.append("status", status.toString());
  if (type !== undefined && type !== null)
    params.append("type", type.toString());
  const url = `${Endpoint.accountant.getCoupons}?${params.toString()}`;
  return HTTP_CLIENT.get(url);
};

const getCouponByIdService = (id: number) => {
  return HTTP_CLIENT.get(`${Endpoint.accountant.getCouponById}/${id}`);
};

const updateCouponService = (id: number, data: any) => {
  return HTTP_CLIENT.post(`${Endpoint.accountant.updateCoupon}/${id}`, data);
};

const deleteCouponService = (id: number) => {
  return HTTP_CLIENT.delete(`${Endpoint.accountant.deleteCoupon}/${id}`);
};

const getBankAccountsService = (
  searchText: any,
  activeTab: any,
  itemsPerPage: number
) => {
  const params = new URLSearchParams();
  if (searchText) params.append("search", searchText);
  if (activeTab) params.append("page", activeTab.toString());
  if (itemsPerPage) params.append("per_page", itemsPerPage.toString());
  const url = `${Endpoint.accountant.getBankAccounts}?${params.toString()}`;
  return HTTP_CLIENT.get(url);
};

export {
  getEarningsService,
  uploadReceiptService,
  getEarningBookSalesService,
  getBankAccountsService,
  getStatsService,
  createCouponService,
  getCouponsService,
  getCouponByIdService,
  updateCouponService,
  deleteCouponService,
};
